import { render, staticRenderFns } from "./quick-signin-dialog.vue?vue&type=template&id=4ee7a5a6&scoped=true"
import script from "./quick-signin-dialog.vue?vue&type=script&lang=js"
export * from "./quick-signin-dialog.vue?vue&type=script&lang=js"
import style0 from "./quick-signin-dialog.vue?vue&type=style&index=0&id=4ee7a5a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee7a5a6",
  null
  
)

export default component.exports